<div class="tenant-sla-card rounded-3 bg-white border shadow-sm">
  <div class="d-flex align-items-center justify-content-between gap-3 mb-3">
    <div class="text-uppercase tenant-sla-heading">
      SLA targets &amp; workflows &middot; {{ targets_count }}
    </div>
    <button
      type="button"
      class="btn btn-light btn-sm rounded-small border px-3"
      :disabled="loading_targets"
      @click="load_targets"
    >
      {{ loading_targets ? 'Loading...' : 'Refresh' }}
    </button>
  </div>

  <div
    v-if="loading_targets"
    class="tenant-settings-empty-state text-center text-secondary"
  >
    Loading SLA configurations...
  </div>

  <div
    v-else-if="targets_error"
    class="tenant-settings-empty-state text-center"
  >
    <div class="text-danger mb-3">{{ targets_error }}</div>
    <button type="button" class="btn btn-light btn-sm border px-3" @click="load_targets">
      Try again
    </button>
  </div>

  <div
    v-else-if="!targets.length"
    class="tenant-settings-empty-state text-center text-secondary"
  >
    No active SLA configurations have been found.
  </div>

  <div v-else class="tenant-sla-table-wrap">
    <table class="tenant-sla-table">
      <thead>
        <tr>
          <th>SLA</th>
          <th>Workflow</th>
          <th>Warning</th>
          <th>Target</th>
          <th>Escalation</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="target in targets" :key="target.id">
          <td>
            <div class="tenant-rule-code">{{ target.name }}</div>
            <div class="tenant-rule-copy">{{ target.description || 'No description provided' }}</div>
          </td>
          <td>
            <div v-if="target.workflows.length" class="d-flex flex-wrap gap-1">
              <span
                v-for="workflow in target.workflows"
                :key="workflow.id"
                class="tenant-case-domain-badge is-blue"
              >
                {{ workflow.workflow_name }}
              </span>
            </div>
            <span v-else class="text-secondary">Not assigned</span>
          </td>
          <td>{{ target.warning_label }}</td>
          <td>{{ target.target_label }}</td>
          <td>{{ target.escalation_label }}</td>
          <td>
            <span class="tenant-rule-status" :class="target.status_class">
              {{ target.status_label }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
